import { useLang } from "../../i18n/LangContext";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { ArrowLeft } from "lucide-react";
import { DayContentBlock } from "./DayContentBlock";
import { L } from "./lib";

export function DayDetail({ detail, draft, setDraft, busy, onComplete, onClose }) {
  const { t, lang } = useLang();
  return (
    <Card data-testid={`day-detail-${detail.day_number}`} className="bg-[#161923] border-white/5">
      <CardContent className="p-5 sm:p-6 space-y-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#10B981] font-semibold">
              {t("edu.day")} {detail.day_number} {t("edu.of")} {detail.journey.duration_days}
            </div>
            <h2 className="mt-2 font-[Outfit] text-2xl font-extrabold text-white">{L(detail.title, lang)}</h2>
            {L(detail.description, lang) && <p className="mt-1 text-sm text-slate-400">{L(detail.description, lang)}</p>}
          </div>
          <Button data-testid="day-back-btn" variant="ghost" onClick={onClose} className="text-slate-300 hover:bg-white/5 h-9">
            <ArrowLeft className="h-4 w-4 mr-1" /> {t("common.back")}
          </Button>
        </div>

        {detail.content.map((c) => (
          <DayContentBlock key={c.content_id} item={c} draft={draft} setDraft={setDraft} />
        ))}

        {detail.requirements.material && (
          <label className="flex items-center gap-2 text-sm text-slate-300">
            <input type="checkbox" data-testid="day-material-checkbox" checked={draft.material}
              onChange={(e) => setDraft({ ...draft, material: e.target.checked })} className="accent-[#10B981]" />
            {t("edu.markMaterialRead")}
          </label>
        )}

        <Button data-testid="day-complete-btn" disabled={busy} onClick={onComplete}
          className="w-full h-11 bg-[#FF3B30] hover:bg-[#E02E24] text-white font-semibold">
          {busy ? t("common.loading") : t("edu.completeDay")}
        </Button>
      </CardContent>
    </Card>
  );
}
